import type { ComponentType, SVGProps } from 'react';

import styles from './ComingSoon.module.css';

interface ComingSoonProps {
  /** Page name shown in the title row, e.g. "Curate". */
  title: string;
  /** Short descriptor shown after the divider, e.g. "Personalized Training". */
  subtitle: string;
  /** Icon rendered inside the centered card. */
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  /** Card heading, e.g. "Curate is on the way". */
  heading: string;
  /** Supporting sentence describing what will land here. */
  body: string;
}

/**
 * Uniform "Coming Soon" placeholder for nav destinations whose feature is not
 * yet built. Keeps the standard page title row so navigation is undisrupted,
 * then centers a simple card with an icon, a Coming Soon badge, heading, and a
 * one-line description.
 */
export function ComingSoon({ title, subtitle, icon: Icon, heading, body }: ComingSoonProps) {
  const headingId = `${title.toLowerCase()}-heading`;

  return (
    <section className={styles.page} aria-labelledby={headingId}>
      <header className={styles.titleRow}>
        <h1 id={headingId} className={styles.title}>
          {title}
          <span className={styles.titleDivider}>·</span>
          <span className={styles.titleSub}>{subtitle}</span>
        </h1>
      </header>

      <div className={styles.card}>
        <span className={styles.icon} aria-hidden="true">
          <Icon width={28} height={28} />
        </span>
        <span className={styles.badge}>Coming Soon</span>
        <h2 className={styles.cardTitle}>{heading}</h2>
        <p className={styles.cardBody}>{body}</p>
      </div>
    </section>
  );
}
